import React from 'react';

import { TextField, useRecordContext } from 'react-admin';

import { get, isEmpty, keyBy } from 'lodash';

import { Typography } from '@mui/material';

import Answer from '../Answer';

import { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { SourceOfFundsParameters } from '../../questionParameters';

export type SourceOfFundsFormAnswer = {
  options: string[];
  other?: string;
};

const ValueField = ({
  extraParameters,
}: {
  extraParameters?: SourceOfFundsParameters;
  language?: Languages;
}) => {
  const record = useRecordContext<{
    value: SourceOfFundsFormAnswer;
    sx?: any;
  }>();

  if (!record) return null;

  const options = get(record, 'value.options');
  const other = get(record, 'value.other');
  const sx = get(record, 'sx', {});

  if (isEmpty(options)) return <Typography>-</Typography>;

  const mapFields = keyBy(
    extraParameters?.options?.map((option) => ({
      id: option.id,
      name: extraParameters.choiceLabels?.[option.id] ?? option.label,
    })),
    'id',
  );

  const mappedValues = options?.map((v: string) => get(mapFields, v, { name: v }).name);
  if (other) mappedValues.push(other);

  const value = mappedValues.join(', ');

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const SourceOfFunds = ({
  extraParameters,
}: {
  extraParameters?: SourceOfFundsParameters;
}) => (
  <Answer
    label={extraParameters?.label ?? ''}
    source="sourceOfFunds"
    datapoint={conflictFields.SOURCE_OF_FUNDS}
    identificationInfo={undefined}
  >
    <ValueField extraParameters={extraParameters} />
  </Answer>
);

SourceOfFunds.ValueField = ValueField;

export default SourceOfFunds;
